<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <span>{{ $t("legal.menu.privacy") }} </span>
            </div>
        </template>
        <template #sidebarMain>
            <CardToggle :title="$t('legal.privacy.stored_data')">
                <div class="space-y-5">
                    <FormToggleSm :title="$t('shared.first_name')" v-model="legal.storeFirstName" />
                    <FormToggleSm :title="$t('shared.last_name')" v-model="legal.storeLastName" />
                    <FormToggleSm
                        :title="$t('shared.contact_adress')"
                        v-model="legal.storeAddress"
                    />
                    <FormToggleSm :title="$t('shared.email_adress')" v-model="legal.storeEmail" />
                    <FormToggleSm
                        :title="$t('shared.phone_number')"
                        v-model="legal.storeTelephone"
                    />
                    <FormToggleSm title="PESEL" v-model="legal.storePesel" />
                    <FormToggleSm title="NIP" v-model="legal.storeNip" />
                    <FormToggleSm :title="$t('shared.id_number')" v-model="legal.storeIdNumber" />
                    <FormToggleSm :title="$t('shared.birth_date')" v-model="legal.storeBirthdate" />
                    <FormToggleSm :title="$t('shared.others')" v-model="legal.storeOther" />
                    <FormTextArea
                        v-if="legal.storeOther"
                        :title="$t('legal.privacy.other_label')"
                        v-model="legal.storeOtherName"
                        :rows="5"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('legal.privacy.store_features')">
                <div class="space-y-5">
                    <FormToggleSm
                        :title="$t('legal.privacy.register_account')"
                        v-model="legal.registerAccount"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.newsletter')"
                        v-model="legal.newsletter"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.contact_form')"
                        v-model="legal.contactForm"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.context_ads')"
                        v-model="legal.contextAds"
                    />
                    <FormToggleSm
                        :title="$t('legal.privacy.behavioral_ads')"
                        v-model="legal.behaviorAds"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('legal.privacy.plugins')">
                <div class="space-y-5">
                    <FormToggleSm title="Facebook" v-model="legal.facebookAnalytics" />
                    <FormToggleSm title="Google" v-model="legal.googleAnalytics" />
                    <FormToggleSm title="X (Twiter)" v-model="legal.twitterAnalytics" />
                    <FormToggleSm title="Linkedin" v-model="legal.linkedinAnalytics" />
                </div>
            </CardToggle>
            <CardToggle :title="$t('legal.pages_terms.extra_title')">
                <div class="space-y-5">
                    <p class="ct-text">
                        {{ $t("legal.pages_terms.extra_info") }}
                    </p>
                    <FormToggleSm
                        :title="$t('legal.pages_terms.extra')"
                        v-model="legal.userPolicy"
                    />
                    <template v-if="legal.userPolicy">
                        <FormInput
                            :title="$t('legal.pages_terms.extra_label')"
                            :placeholder="$t('legal.pages_terms.extra_placeholder')"
                            v-model="legal.userPolicyMenu"
                            :help="$t('legal.pages_terms.extra_menu_help')"
                        />
                        <FormInput
                            :title="$t('legal.pages_terms.extra_menu')"
                            :placeholder="$t('legal.pages_terms.extra_placeholder')"
                            v-model="legal.userPolicyTitle"
                            :help="$t('legal.pages_terms.extra_menu_help')"
                        />
                        <FormTextArea
                            :title="$t('legal.pages_terms.extra_content_label')"
                            v-model="legal.userPolicyContent"
                            :placeholder="$t('legal.pages_terms.extra_content_placeholder')"
                            :rows="10"
                            :help="$t('legal.pages_terms.extra_content_help')"
                        />
                    </template>
                </div>
            </CardToggle>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormToggleSm, FormInput, FormTextArea } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        PageSidebar,
        FormToggleSm,
        FormInput,
        FormTextArea,
        CardToggle,
        cSaveButton,
    },
    computed: {
        ...mapState("legal", ["legal", "hasChanges"]),
    },
    methods: {
        ...mapActions("legal/projects", ["saveSnapshot"]),
    },
};
</script>
